import { CanvasDatabaseAri } from '@atlassian/ari/canvas/database';
import { proxy } from 'valtio';

import { Deferrable } from '@canvas/deferrable';
import {
  type FrameContext,
  type FrameState,
  type FrameToken,
} from '@canvas/frame-api-types';

const emptyState: FrameState = {
  container: '',
  board: '',
  accessToken: '',
  mediaToken: '',
  mediaBaseUrl: '',
  mediaCollectionId: '',
  dataSecurityPolicy: undefined,
};

export const currentHostFrameContext = proxy<FrameContext>({
  data: emptyState,
});

// frameContextReady resolves when updateFrameContext() is first called
// await frameContextReady.get() if there's a chance that currentHostFrameContext may not be set yet
export const frameContextReady = new Deferrable<FrameContext>();

export const updateFrameContext = (token: FrameToken | undefined) => {
  currentHostFrameContext.data.container = token?.container ?? '';
  currentHostFrameContext.data.board = token?.board ?? '';
  currentHostFrameContext.data.accessToken = token?.accessToken ?? '';
  currentHostFrameContext.data.mediaToken = token?.mediaToken ?? '';
  currentHostFrameContext.data.mediaBaseUrl = token?.mediaBaseUrl ?? '';
  currentHostFrameContext.data.mediaCollectionId = token?.mediaCollectionId ?? '';
  currentHostFrameContext.data.dataSecurityPolicy = token?.dataSecurityPolicy;

  frameContextReady.resolve(currentHostFrameContext);
};

export const getFrameContextReferenceId = () => {
  if (currentHostFrameContext.data.board !== '') {
    return CanvasDatabaseAri.parse(currentHostFrameContext.data.board).databaseId;
  }

  return undefined;
};
